import type { PayerBase, TransactionItemDetail } from 'models';
import type { TransactionViewBasedOnUserDisplayMode } from '..';

import { UserDetailed } from './user-detailed';
import { UserSimple } from './user-simple';

type P = {
  displayMode?: TransactionViewBasedOnUserDisplayMode;
  transactionItem: TransactionItemDetail;
  user: PayerBase;
};

const TransactionAvatarWrapper = ({ displayMode = 'simple', ...rest }: P) => {
  switch (displayMode) {
    case 'detailed':
      return <UserDetailed {...rest} />;
    case 'simple':
      return <UserSimple {...rest} />;
  }
};

export default TransactionAvatarWrapper;
